import React, { useEffect } from 'react';
import { Movie } from './App';

interface MovieDetailProps {
  movie: Movie;
  onClose: () => void;
  onPlayTrailer: () => void;
  watchProviders: any; // We'll define a more specific type later
}

const MovieDetail: React.FC<MovieDetailProps> = ({ movie, onClose, onPlayTrailer, watchProviders }) => {
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    // Add event listener
    document.addEventListener('keydown', handleEscKey);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]); // Only re-run the effect if onClose changes

  const rating = movie.vote_average.toFixed(1);

  return (
    <div className="movie-detail-overlay">
      <button className="close-button" onClick={onClose}>&times;</button>
      <div 
        className="movie-detail-backdrop"
        style={{ backgroundImage: `url(https://image.tmdb.org/t/p/original${movie.backdrop_path})` }}
      >
        <div className="movie-detail-content">
          <div className="movie-info">
            <div className="movie-header-overlay">
              <h2>{movie.title}</h2>
              <div className="movie-meta">
                <div className="rating-bar">
                  <div 
                    className="rating-fill" 
                    style={{ width: `${movie.vote_average * 10}%` }}
                  ></div>
                  <span className="rating-text">{rating}</span>
                </div>
                <span className="release-date">{movie.release_date.split('-')[0]}</span>
              </div>
              <p className="movie-overview">{movie.overview}</p>
              <button className="play-trailer-button" onClick={onPlayTrailer}>
                <span className="play-icon">▶</span> Play Trailer
              </button>
              
              {watchProviders && watchProviders.results && watchProviders.results.US && (
                <div className="watch-options">
                  {watchProviders.results.US.rent && (
                    <div className="provider-section">
                      <h4>Rent:</h4>
                      {watchProviders.results.US.rent.map((provider: any) => (
                        <a 
                          key={provider.provider_id} 
                          href={watchProviders.results.US.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="provider-link"
                        >
                          <img 
                            src={`https://image.tmdb.org/t/p/original${provider.logo_path}`} 
                            alt={provider.provider_name} 
                            title={provider.provider_name}
                            className="provider-logo"
                          />
                        </a>
                      ))}
                    </div>
                  )}
                  {watchProviders.results.US.buy && (
                    <div className="provider-section">
                      <h4>Buy:</h4>
                      {watchProviders.results.US.buy.map((provider: any) => (
                        <a 
                          key={provider.provider_id} 
                          href={watchProviders.results.US.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="provider-link"
                        >
                          <img 
                            src={`https://image.tmdb.org/t/p/original${provider.logo_path}`} 
                            alt={provider.provider_name} 
                            title={provider.provider_name}
                            className="provider-logo"
                          />
                        </a>
                      ))}
                    </div>
                  )}
                  {watchProviders.results.US.flatrate && (
                    <div className="provider-section">
                      <h4>Stream:</h4>
                      {watchProviders.results.US.flatrate.map((provider: any) => (
                        <a 
                          key={provider.provider_id} 
                          href={watchProviders.results.US.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="provider-link"
                        >
                          <img 
                            src={`https://image.tmdb.org/t/p/original${provider.logo_path}`} 
                            alt={provider.provider_name} 
                            title={provider.provider_name}
                            className="provider-logo"
                          />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieDetail;
